import React from 'react';
import { FormHelperText, MenuItem, Stack } from '@mui/material';
import { Controller } from 'react-hook-form';

import {
  RadioGroupInput,
  DynamicDatepickerInput,
} from 'shared-components/Input';
import { RadioInput } from 'shared-components/Input/RadioInput';
import {
  CheckboxGroupInput,
  CheckboxInput,
} from 'shared-components/Input/CheckboxInput';
import { SelectInput, menuProps } from 'components/Input/SelectInput.styles';
import { QuestionCard, QuestionTitle, QuestionDescription } from './styles';

export const PageForm = ({ questions, methods }) => {
  const optionsStyles = {
    '& > .MuiRadio-root' : {
      flex : '1',
    },
  };

  const renderQuestion = ({ questionType, items }, { ref, ...field }) => {
    switch (questionType) {
      case 'radio':
        return (
          <RadioGroupInput
            direction={{ xs: 'column' }}
            optionsStyles={optionsStyles}
            {...field}
            ref={ref}>
            {items.map(({ id, label }) => (
              <RadioInput
                key={id} value={id} label={label}
              />
            ))}
          </RadioGroupInput>
        );
      case 'select':
        return (
          <SelectInput
            label='Select option'
            menuProps={menuProps}
            {...field}
            inputRef={ref}>
            {items.map(({ id, label }) => (
              <MenuItem
                key={id} value={id}>
                {label}
              </MenuItem>
            ))}
          </SelectInput>
        );
      case 'checkbox':
      {
        const { onChange, value: values, ...rest } = field;
        const handleChange = ({ target }) =>
          target.value
            ? onChange(values ? [...values, target.name].sort() : [target.name])
            : onChange(values?.filter?.((option) => option !== target.name));
        return (
          <CheckboxGroupInput
            direction={{ xs: 'column' }}
            optionsStyles={optionsStyles}
            {...rest}
            ref={ref}>
            {items.map(({ id, label, value, disabled }) => {
              const checked = Boolean(values?.includes?.(value));
              return (
                <CheckboxInput
                  key={id}
                  name={value}
                  label={label}
                  disabled={disabled}
                  checked={checked}
                  onChange={() =>
                    handleChange({
                      target : { name: value, value: !checked },
                    })
                  }
                />
              );
            })}
          </CheckboxGroupInput>
        );
      }
      case 'datepicker':
        return <DynamicDatepickerInput />;
      default:
        break;
    }
  };

  return (
    <Stack
      spacing='10px'>
      {questions?.map((question) => (
        <QuestionCard
          key={question?.id}>
          <QuestionTitle>{question?.questionTitle}</QuestionTitle>
          {question?.questionDescription && (
            <QuestionDescription>
              {question?.questionDescription}
            </QuestionDescription>
          )}
          <Controller
            name={question?.id}
            control={methods.control}
            rules={question?.rules}
            render={({ field }) => renderQuestion(question, field)}
          />
          {question?.questionHelperText && (
            <FormHelperText>{question?.questionHelperText}</FormHelperText>
          )}
        </QuestionCard>
      ))}
    </Stack>
  );
};
